export const parseBool = (v: unknown): boolean => v === 'true';
